import ListAltIcon from '@material-ui/icons/ListAlt';
import { useLocation } from 'react-router-dom';
import PopupIcon from './popup-icon';

interface AboutIconProps {
  about: string | null;
  pathname?: string;
}

function AboutIcon({ about, pathname }: AboutIconProps) {
  const location = useLocation();

  return (
    <PopupIcon
      to={{
        pathname,
        search: 'anchor=about',
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      }}
      icon={<ListAltIcon />}
      testId='about-link-icon'
      content={about || undefined}
      emptyText='There is no about available.'
      isNoIcon={!about}
    />
  );
}

export default AboutIcon;
